




















import { VBTooltip } from 'bootstrap-vue';

export default {
  name: 'InsertVariableButton',
  directives: {
    BTooltip: VBTooltip,
  },
  props: {
    variables: {
      type: Array,
      required: true,
    },
  },
  methods: {
    itemClicked(variable: string) {
      this.$emit('item-clicked', variable);
    },
  },
};
